var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_47_1",
    "data-name": "Component 47 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17184",
    "data-name": "Rectangle 17184",
    width: 36,
    height: 36,
    rx: 5,
    fill: "#e6eeff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "options",
    transform: "translate(9.914 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8940",
    "data-name": "Path 8940",
    d: "M6.6,12.957V2.9a.9.9,0,1,0-1.8,0V12.957a2.7,2.7,0,0,0,0,5.074v1.062a.9.9,0,1,0,1.8,0V18.031a2.7,2.7,0,0,0,0-5.074Zm-.9,3.437a.9.9,0,1,1,.9-.9A.9.9,0,0,1,5.7,16.394Z",
    transform: "translate(-3.024 -1.992)",
    fill: "#0466c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8941",
    "data-name": "Path 8941",
    d: "M20.4,11.9a2.7,2.7,0,0,0-1.8-2.537V2.9a.9.9,0,1,0-1.8,0V9.359a2.7,2.7,0,0,0,0,5.074v4.66a.9.9,0,1,0,1.8,0v-4.66A2.7,2.7,0,0,0,20.4,11.9Zm-2.7.9a.9.9,0,1,1,.9-.9A.9.9,0,0,1,17.7,12.8Z",
    transform: "translate(-4.228 -1.992)",
    fill: "#0466c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8942",
    "data-name": "Path 8942",
    d: "M14.4,4.7a2.7,2.7,0,1,0-3.6,2.537V19.092a.9.9,0,1,0,1.8,0V7.235A2.7,2.7,0,0,0,14.4,4.7Zm-2.7.9a.9.9,0,1,1,.9-.9A.9.9,0,0,1,11.7,5.6Z",
    transform: "translate(-3.623 -1.991)",
    fill: "#0466c8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSvg);
export default __webpack_public_path__ + "static/media/filterSvg.8292688e.svg";
export { ForwardRef as ReactComponent };